namespace Matrix.Data {
    export class MarketExchangeColumns {
        static columnsKey = 'Data.MarketExchange';
    }
}
